up.compiler('.js-flip_subscription_card', element => {
  const flippedClass = 'subscription_card--is_flipped'
  const flipButton = element.querySelector('.js-flip_subscription_card_flip_button')
  const unflipButton = element.querySelector('.js-flip_subscription_card_unflip_button')
  const flippedHeader = element.querySelector('.js-flip_subscription_card_flipped_header')

  if (!flippedHeader || !flipButton || !unflipButton) {
    return
  }

  flippedHeader.tabIndex = -1

  function flip() {
    element.classList.add(flippedClass)
    flippedHeader.focus()
  }

  function unflip() {
    element.classList.remove(flippedClass)
    flipButton.focus()
  }

  flipButton.addEventListener('click', flip)
  unflipButton.addEventListener('click', unflip)
})
